import 'angular:locale/data:zh-Hant';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "zh-Hant";
